import { PayloadAction } from '../../../store.model';
import { ActionType } from '../transcript-dialog.action';
import { TranscriptDialogState } from '../transcript-dialog.state';

import { ResetNav } from './reset-nav.action';

export function resetNavReducer(
    state: TranscriptDialogState,
    _: PayloadAction<ActionType.COACHING_DETAIL__TD__RESET_NAV, ResetNav>,
): TranscriptDialogState {
    try {
        return {
            ...state,
            willNavigate: null,
            navigateCmtId: null,
            navigateDraftId: null,
            cmtNotesFocus: state.primaryFocusTag,
        };
    } catch (err) {
        console.log(err);
        return state;
    }
}
